module.exports = __webpack_public_path__ + "img/AddLocationOutlined.6dc7ddbf.svg";